import {
	requestPublic,
	request
} from './request';
export function GetAdminLoginToken(data) {
    return requestPublic({
        url: '/api4/SBCenterWebApi/AdminLogin/GetAdminLoginToken',
        method: 'get',
        params: data,
    })
}
export function loginRoleInformationV2() {
	return request({
		url: '/api4/SBCenterAdminApi/Admin/LoginRoleInformation',
		method: 'get',
	})
}
export function AdminLoginByRolesId(data) {
	return request({
		url: '/api4/SBCenterAdminApi/Admin/AdminLoginByRolesId',
		method: 'get',
		params: data,
	})
}

